(() => {
  const params = new URLSearchParams(location.search);
  if (params.get('looklab_checkout') !== '1') return;
  const config = document.querySelector('[data-looklab-product]');
  if (!config) return;
  const lensId = params.get('lens');
  const requestId = params.get('selection');
  if (!/^\d+$/.test(lensId || '') || !/^[a-zA-Z0-9-]{16,64}$/.test(requestId || '')) return;
  const productId = config.dataset.productId;
  const frameId = config.dataset.variantId;
  const root = window.Shopify.routes.root;
  const api = 'https://app.lensadvizor.com/api';
  const shop = window.Shopify.shop;
  const bundle = `looklab-${requestId}`;
  const unique = `non_prescription__${productId}__${requestId}`;
  const panel = document.createElement('div');
  panel.setAttribute('role', 'status');
  panel.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:#e7e7e4;display:grid;place-content:center;padding:24px;text-align:center;color:#272727;font:16px/1.5 sans-serif';
  panel.textContent = 'Preparing your Infy and selected lenses…';
  document.body.append(panel);
  async function json(url, options) {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error('Your selection could not be prepared. Please try again.');
    return response.json();
  }
  const post = (url, body) => json(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  async function run() {
    const assigned = await json(`${api}/collection/product/${productId}/?variant=${frameId}&api_version=2`);
    if (!assigned.variant_ids.map(String).includes(frameId)) throw new Error('This frame is not assigned to a lens flow.');
    const flow = await json(`${api}/collection/${assigned.collection}/prescription-types/?product_id=${productId}&api_version=2`);
    const pt = flow.prescriptionTypes.find(type => type.name === 'non_prescription');
    if (!flow.is_active || !pt) throw new Error('The non-prescription lens flow is unavailable.');
    const lenses = await json(`${api}/collection/${assigned.collection}/items/?prescription_type=non_prescription&prescription_id=${encodeURIComponent(pt.id)}&api_version=2`);
    const lens = lenses.find(item => ['8366277984411', '7635257327771'].includes(String(item.shopify_id)) && item.variants.some(v => String(v.variant_id) === lensId));
    const variant = lens?.variants.find(v => String(v.variant_id) === lensId);
    if (!variant) throw new Error('This lens selection is no longer available. Please return to LookLab.');
    const stock = String(lens.shopify_id) === '8366277984411';
    const settings = await json(`${api}/store/settings?store=${encodeURIComponent(shop)}&product_id=${productId}&api_version=2`);
    const variantConfig = settings.assigned_variants?.[frameId]?.settings;
    if (!variantConfig || variantConfig.useSingleLineBundling || pt.settings.bundleNatively) throw new Error('The lens bundling settings have changed. Please select lenses in store.');
    const common = { _bundleId: bundle, _unique_identifier: unique, 'Prescription Type': 'Non-Prescription', 'Configured in': 'LookLab' };
    const name = stock ? 'Stock dark grey/black — included' : `${lens.name} - ${variant.name}`;
    const frameProperties = { ...common, _productType: 'frame', _lens_variant_id: lensId, Lens: name };
    const lensProperties = { ...common, _productType: 'lens', _base_variant_id: frameId, 'Lens Group': lens.group_title, Frame: config.dataset.productTitle };
    const items = [{ id: frameId, quantity: 1, properties: frameProperties }];
    if (!stock) items.push({ id: lensId, quantity: 1, properties: lensProperties });
    let cart = await json(`${root}cart.js`);
    const existing = cart.items.filter(item => item.properties?._bundleId === bundle);
    if (existing.length && (existing.length !== items.length || !items.every(item => existing.some(line => String(line.variant_id) === item.id && line.quantity === 1)))) throw new Error('This configuration is already in your cart with different quantities. Please review your cart.');
    if (!existing.length) await post(`${root}cart/add.js`, { items });
    cart = await json(`${root}cart.js`);
    const paired = cart.items.filter(item => item.properties?._bundleId === bundle);
    if (paired.length !== items.length) throw new Error('Please review your cart before continuing.');
    const total = paired.reduce((sum, item) => sum + item.final_line_price, 0);
    const expected = Number(params.get('total'));
    if (!Number.isSafeInteger(expected) || total !== expected) throw new Error('The price has changed. Please review the current price in your cart before checkout.');
    const payload = {
      cart_token: cart.token, prescription_type: 'non_prescription', method: '', prescription_file: '', prescription_setting: {},
      product_id: productId, order_note: '', unique_identifier: unique,
      lens: { ...variant, price: stock ? 0 : variant.price, base_product_id: productId, base_product_title: config.dataset.productTitle, name, lens_group_title: lens.group_title, lens_group_type: lens.group_type },
      store_settings: { flowId: assigned.collection, prescriptionType: pt, excludeOrderTag: settings.settings.excludeOrderTag || false, orderTag: settings.settings.orderTag || '', addBaseProduct: true, sendOrderToLab: pt.settings.sendOrderToLab, variantConfig: { ...variantConfig, layout: undefined } },
      additional_informations: { frameProperties: { 'Configured in': 'LookLab' }, lensProperties: stock ? { 'Included with frame': 'Yes' } : { Color: variant.option1, Style: variant.option2, Shade: variant.option3 }, addOnProperties: {} }, addons: {}
    };
    await post(`${api}/prescriptions/?shop=${encodeURIComponent(shop)}&api_version=2`, payload);
    location.replace(`${root}checkout`);
  }
  run().catch(error => {
    panel.replaceChildren();
    const message = document.createElement('p');
    message.textContent = error.message;
    const cart = document.createElement('a');
    cart.href = `${root}cart`;
    cart.textContent = 'Review cart';
    const back = document.createElement('a');
    back.href = config.href;
    back.textContent = 'Return to LookLab';
    panel.append(message, cart, back);
  });
})();
